
import { Outlet, useSearchParams } from "react-router-dom";
import HeaderComponent from "../header";
import AppTabsComponent from "../shared/appTabsComponent";
import { useCallback, useMemo, useState } from 'react';
import AccessDenied from "../toolbar.component/accessDenied";


const SettingsTabs = () => {
    const [isAccessDenied, setIsAccessDenied] = useState(false);
    const [searchParams] = useSearchParams();
    const keyValue = searchParams.get("key");
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    const roleName = decodeURIComponent(pathSegments[pathSegments.length - 1]);
    const cardName = decodeURIComponent(pathSegments[pathSegments.length - 1]);
    const breadCrumbList = useMemo(() => {
        if (window.location.pathname.includes("settings/programs/cardDetails")) {
            return [
                { id: "1", bname: "Settings" },
                { id: "2", bname: "Programs", url: "/settings/programs" },
                { id: "3", bname: cardName ? cardName : "Card Name" }
            ]
        }
        else if (window.location.pathname.includes("users/add")) {
            return [
                { id: "1", bname: "Settings" },
                { id: "2", bname: "Users", url: "/settings/users" },
                { id: "4", bname: "Add" }]
        }
        else if (window.location.pathname.includes("users/edit")) {
            return [
                { id: "1", bname: "Settings" },
                { id: "2", bname: "Users", url: "/settings/users" },
                { id: "3", bname: keyValue }]
        }
        else if (window.location.pathname.includes("settings/users")) {
            return [
                { id: "1", bname: "Settings" },
                { id: "2", bname: "Users" }]
        }
        else if (window.location.pathname.includes("settings/programs")) {
            return [
                { id: "1", bname: "Settings" },
                { id: "2", bname: "Programs" }]
        }

        else if (window.location.pathname.includes("settings/roles/managePermissions")) {
            return [
                { id: "1", bname: "Settings" },
                { id: "2", bname: "Roles", url: "/settings/roles" },
                { id: "2", bname: "Manage Permissions" },
                { id: "4", bname: roleName }]
        }
        else if (window.location.pathname.includes("settings/roles")) {
            return [
                { id: "1", bname: "Settings" },
                { id: "2", bname: "Roles" }]
        }
        else if (window.location.pathname.includes("settings/config")) {
            return [
                { id: "1", bname: "Settings" },
                { id: "2", bname: "Config", url: "/settings/config" },
            ]
        }
    }, [window.location.pathname])

    const handleAccessDenied = useCallback((flag) => {
        setIsAccessDenied(flag)
    },[])

    return (
        <>
            <HeaderComponent breadCrumbList={!isAccessDenied ? breadCrumbList : []} />
            {!isAccessDenied && 
                <div className='profile-tabs md:flex gap-0.5'>
                    <AppTabsComponent serviceName={"CardsManageService.Settings"} isNoRouting={false} tabPosition={"left"} handleAccessDenied={handleAccessDenied} />
                    <div className="md:w-[77%] w-full border border-StrokeColor md:p-4 p-2 rounded-5 setting-tab-p flex-1">
                        <Outlet />
                    </div>
                </div>}
            {isAccessDenied && <AccessDenied />}
        </>
    )
}
export default SettingsTabs